import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch, getRequiredCurrentUserHeaders } from "./apiClient";

function getTelecallingUserHeaders() {
  return getRequiredCurrentUserHeaders({ includeRole: true });
}

export async function fetchTelecallingNotificationSnapshot() {
  const response = await apiFetch(API_ENDPOINTS.telecallingRecords.dashboard, {
    headers: getTelecallingUserHeaders(),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingNotificationReadFailed);
  }

  if (!response.ok || !result?.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingNotificationFetchFailed,
    );
  }

  return {
    notification: result.data?.urgent_notification || null,
    insertedCount:
      Number(result.data?.followup_notifications_inserted) || 0,
  };
}

export async function acknowledgeTelecallingNotification({ phone, agent }) {
  const response = await apiFetch(
    API_ENDPOINTS.telecallingRecords.acknowledgeNotification,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getTelecallingUserHeaders(),
      },
      body: JSON.stringify({ phone, agent }),
    },
  );

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(
      API_ERROR_MESSAGES.telecallingNotificationAcknowledgeReadFailed,
    );
  }

  if (!response.ok || !result?.success) {
    throw new Error(
      result?.message ||
        API_ERROR_MESSAGES.telecallingNotificationAcknowledgeFailed,
    );
  }

  return result;
}

export async function fetchTelecallingRecordsMetadata() {
  const response = await apiFetch(API_ENDPOINTS.telecallingRecords.metadata);

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingMetadataReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingMetadataFetchFailed,
    );
  }

  return result.data;
}

export async function fetchTelecallingRecordsSummary() {
  const response = await apiFetch(API_ENDPOINTS.telecallingRecords.summary, {
    headers: {
      "Content-Type": "application/json",
      ...getTelecallingUserHeaders(),
    },
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingSummaryReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingSummaryFetchFailed,
    );
  }

  return result;
}

export async function fetchTelecallingRecordsList({ page = 1, status = "" } = {}) {
  const params = new URLSearchParams();

  if (status) {
    params.set("status", status);
  }

  if (status || page > 1) {
    params.set("page", String(page));
  }

  const queryString = params.toString();
  const response = await apiFetch(
    queryString
      ? `${API_ENDPOINTS.telecallingRecords.list}?${queryString}`
      : API_ENDPOINTS.telecallingRecords.list,
    {
      headers: getTelecallingUserHeaders(),
    },
  );

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingListReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingListFetchFailed,
    );
  }

  return result;
}

export async function searchTelecallingRecord(phone) {
  const response = await apiFetch(API_ENDPOINTS.telecallingRecords.search, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone }),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingSearchReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingSearchFailed,
    );
  }

  return result.data;
}

export async function saveTelecallingCallEntry(entry) {
  const response = await apiFetch(API_ENDPOINTS.telecallingRecords.callEntry, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getTelecallingUserHeaders(),
    },
    body: JSON.stringify(entry),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.telecallingCallEntryReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.telecallingCallEntrySaveFailed,
    );
  }

  return result;
}
